import { PaymentMethodBrand } from '../exports/Constants';

/**
 * One place that knows every spelling of a card brand the app can meet:
 *
 * - Stripe `card.brand`: visa, mastercard, amex, discover, diners, jcb, unionpay, cartes_bancaires
 * - Adyen webhook brand (after the backend's partial normalisation): visa, master_card,
 *   american_express, then raw diners, jcb, maestro, cup, dankort, cartebancaire
 * - Spreedly `card_type` / iFrame `fieldEvent.cardType`: visa, master, american_express,
 *   discover, diners_club, jcb, dankort, maestro, unionpay (verified against
 *   number-frame-1.191.min.js on 2026-09-15)
 *
 * The backend stores `payment_method_brand` raw per gateway, so saved-card rows and the live
 * Spreedly form both route through here before picking an icon. Brands without artwork
 * (Cartes Bancaires, Elo, …) resolve to `null` and fall back to a generic glyph or the method name.
 */
const BRAND_BY_ALIAS: Record<string, PaymentMethodBrand> = {
  visa: PaymentMethodBrand.Visa,
  master: PaymentMethodBrand.MasterCard,
  mastercard: PaymentMethodBrand.MasterCard,
  master_card: PaymentMethodBrand.MasterCard,
  mc: PaymentMethodBrand.MasterCard,
  amex: PaymentMethodBrand.AmericanExpress,
  american_express: PaymentMethodBrand.AmericanExpress,
  discover: PaymentMethodBrand.Discover,
  diners: PaymentMethodBrand.DinersClub,
  diners_club: PaymentMethodBrand.DinersClub,
  jcb: PaymentMethodBrand.Jcb,
  unionpay: PaymentMethodBrand.UnionPay,
  union_pay: PaymentMethodBrand.UnionPay,
  cup: PaymentMethodBrand.UnionPay,
  maestro: PaymentMethodBrand.Maestro,
  dankort: PaymentMethodBrand.Dankort,
};

export function normalizeCardBrand(raw: string | null | undefined): PaymentMethodBrand | null {
  if (typeof raw !== 'string') {
    return null;
  }

  return BRAND_BY_ALIAS[raw.trim().toLowerCase()] ?? null;
}
